/**
 * PostGetReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * PostGetReq
 */
export interface PostGetReq {
  /** 帖子ID，逗号分隔 */
  id: string
}

/**
 * PostGetReq Schema
 */
export const PostGetReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '帖子ID，逗号分隔',
      format: 'string',
      type: 'string',
      label: '帖子ID',
    },
  },
  required: ['id'],
  type: 'object',
}
